import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {UsuarioService} from "../../services/usuario.service";
import {LoginService} from "../../services/login.service";
import {MessageService} from "../../core/services/message.service";
import {NgxSpinnerService} from "ngx-spinner";
import {ActivatedRoute, Router} from "@angular/router";
import {Usuario} from "../../models/usuario";
import {FormControl, FormGroup} from "@angular/forms";
import {MatSort, MatTableDataSource, Sort} from "@angular/material";
import {Perfil} from "../../models/perfil";
import {Login} from "../../models/login";
import {PerfilService} from "../../services/perfil.service";

@Component({
	selector: 'app-usuarios',
	templateUrl: './usuarios.component.html',
	styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements OnInit, AfterViewInit {

	public form: FormGroup;
	public usuarios: Array<Usuario> = [];
	public perfis: Array<Perfil> = [];
	public data_source: MatTableDataSource<any>;
	public carregando: boolean = false;
	public pesquisa_realizada: boolean = false;

	@ViewChild(MatSort) sort: MatSort;

	constructor(private usuarioService: UsuarioService, private perfilService: PerfilService, private loginService: LoginService, private messageService: MessageService, private loadingService: NgxSpinnerService, private router: Router, private route: ActivatedRoute) {

	}

	ngOnInit() {

		this.data_source = new MatTableDataSource(this.usuarios);
		let login: Login = this.loginService.getAuth();
		let url: string;
		if(login){
			if(login.perfil != Perfil.ADMINISTRADOR){
				url = "/plano";
				this.router.navigateByUrl(url);
			}
		}else{
			url = "/login";
			this.router.navigateByUrl(url);
		}

		this.form = new FormGroup({
			nome: new FormControl(null, []),
			cpf: new FormControl(null, []),
			email: new FormControl(null, []),
			perfil: new FormControl(null, []),
			situacao: new FormControl(null, [])
		});
		this.carregarPerfis();
	}

	ngAfterViewInit(): void{
		this.data_source.sort = this.sort;
		this.data_source.sortingDataAccessor = (data, header) => data[header];
	}

	sortData(sort: Sort): void{
		const data = this.data_source.data.slice();
		if(!sort.active || sort.direction === ''){
			this.data_source.data = data;
		}
		this.data_source.data = data.sort((a, b) => {
			const is_asc = sort.direction === 'asc';
			switch(sort.active){
				case 'nome': return this.compare(a.txt_nome, b.txt_nome, is_asc);
				case 'cpf': return this.compare(a.num_cpf, b.num_cpf, is_asc);
				case 'email': return this.compare(a.txt_email, b.txt_email, is_asc);
				case 'perfil': return this.compare(a.perfil.sgl_perfil, b.perfil.sgl_perfil, is_asc);
				default: return 0;
			}
		});
	}

	compare(a: number | string, b: number | string, is_asc: boolean): number{
		return (a < b ? -1 : 1) * (is_asc ? 1 : -1);
	}

	carregarUsuarios(perfil: string = null, nome: string = null, cpf: string = null, email: string = null): void {
		this.usuarios = [];
		this.data_source.data = this.usuarios;
		this.pesquisa_realizada = false;
		this.loadingService.show();
		this.carregando = true;
		this.usuarioService.listAll(perfil, nome, cpf, email).subscribe((usuarios: Array<Usuario>) => {
			let tmp_usuarios: Array<Usuario> = [];
			if(usuarios && usuarios.length > 0){
				let login: Login = this.loginService.getAuth();
				usuarios
					.filter( usuario => this.form.value.situacao ? usuario.txt_situacao == this.form.value.situacao : true )
					.forEach((usuario: Usuario) => {
						if(login.txt_email != usuario.txt_email){
							tmp_usuarios.push(usuario);
						}
					});
			}

			this.usuarios = tmp_usuarios
			this.data_source.data = this.usuarios;
			this.loadingService.hide();
			this.carregando = false;
			this.pesquisa_realizada = true;
		}, () => {
			this.loadingService.hide();
			this.carregando = false;
			this.pesquisa_realizada = true;
		});
	}

	validateUsuario(id: number): void{
		this.loadingService.show();
		this.usuarioService.validate(id).subscribe((data) => {
			this.loadingService.hide();
			this.messageService.showSuccess(data.message);
			this.carregarUsuarios(this.form.value.perfil, this.form.value.nome, this.form.value.cpf, this.form.value.email);
		}, (error) => {
			this.loadingService.hide();
			this.messageService.showResponseError(error);
		});
	}

	carregarPerfis(): void{
		this.perfis = [];
		this.pesquisa_realizada = false;
		this.loadingService.show();
		this.carregando = true;
		this.perfilService.listAll().subscribe((perfis: Array<Perfil>) => {
			this.perfis = perfis;
			this.loadingService.hide();
			this.carregando = false;
			this.pesquisa_realizada = true;
		}, () => {
			this.loadingService.hide();
			this.carregando = false;
			this.pesquisa_realizada = true;
		});
	}

}
